import { FC } from "react";

import { IconButton, TooltipHost } from "@bps/fluent-ui";
import { notificationMessages } from "@libs/constants/notification-messages.constants.ts";
import { PhysitrackApiKeyDto } from "@libs/gateways/custom-integration/CustomIntegrationGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { useClipboard } from "@ui-components/hooks/useClipboard.ts";

import { PhysitrackProviderItem } from "./PhysitrackProviderList.tsx";
import { executeAndNotify } from "./utils.ts";

interface PhysitrackProviderMenuProps {
  item: PhysitrackProviderItem;
}

export const PhysitrackProviderMenu: FC<PhysitrackProviderMenuProps> = ({
  item
}) => {
  const { notification, customIntegrations } = useStores();

  const { copy } = useClipboard();

  if (!item.apiKey) {
    return null;
  }

  const copyApiKeyToClipboard = () => {
    copy(item.apiKey!);
  };

  const handleApiKeyUpdate = async () =>
    executeAndNotify<PhysitrackApiKeyDto>(
      () => customIntegrations.regeneratePhysitrackApiKey(item.id),
      notificationMessages.apiKeyUpdated,
      notification
    );

  const handleApiKeyDelete = async () =>
    executeAndNotify<void>(
      () => customIntegrations.deletePhysitrackApiKey(item.id),
      notificationMessages.apiKeyDeleted,
      notification
    );

  const handleEmailApiKeyClick = () =>
    executeAndNotify<void>(
      () => customIntegrations.emailPhysitrackApiKey(item.id),
      notificationMessages.emailIsBeingSent,
      notification
    );

  return (
    <TooltipHost
      content="More"
      styles={{
        root: {
          justifyContent: "center",
          verticalAlign: "center",
          display: "flex"
        }
      }}
    >
      <IconButton
        menuIconProps={{ iconName: "More" }}
        menuProps={{
          items: [
            {
              key: "copy",
              text: "Copy API Key",
              onClick: () => {
                copyApiKeyToClipboard();
              }
            },
            {
              key: "update",
              text: "Update",
              onClick: handleApiKeyUpdate
            },
            {
              key: "remove",
              text: "Remove",
              onClick: handleApiKeyDelete
            },
            {
              key: "email",
              text: "Email",
              onClick: handleEmailApiKeyClick
            }
          ]
        }}
        styles={{
          root: { width: "32px", height: "36px", padding: 0 },
          flexContainer: { width: "32px", height: "36px" }
        }}
      />
    </TooltipHost>
  );
};
